<template>
  <div>
    <vx-card class="mt-base mb-5" :title="activityTitle">
      <p class="mb-5">
        Worksheets are an invaluable tool as a teacher, as they are incredibly versatile. They can
        be helpful to encourage independent learning, contribute to students’ sense of self-reliance
        by featuring an increasing difficulty level, and can be used to help teachers who are
        covering your class.
      </p>

      <ol class="numbered-list mb-10">
        <li>
          Have a think about a topic that you find really interesting, then find a webpage, article,
          text or resource that explains something about that topic.<br /><br />
          Examples could include:<br /><br />
          <ul class="default-list">
            <li>Chapter 1 of Winnie the Pooh by A. A. Milne.</li>
            <li>
              This New York Times Article “Did I Turn Off the Stove? Yes, but Maybe Not the Gas”
            </li>
            <li>This YouTube video “The Immune System Explained” by Kurzegesagt</li>
          </ul>
        </li>
        <li>Next, take another look through Bloom’s Taxonomy from the Resources page.</li>
        <li>
          Write a set of 10 questions for a student to complete based on the Taxonomy.<br />
          You should aim to have at least one question per level. You can use a combination of
          multiple choice, short answer and extended response questions!<br /><br />

          Some tips:<br /><br />
          <ul class="default-list">
            <li>
              Try to base the questions off the learning resource you provide. Imagine that you are
              teaching a new idea to students for the very first time - so try to avoid prior
              knowledge as best as you can.
            </li>
            <li>
              You don’t need to make all of the questions belong in the ‘create’ or ‘analyse’ levels
              of the taxonomy. In fact, it might be a better idea to start out easier to build
              students’ confidence, and then work your way up.
            </li>
          </ul>
        </li>
      </ol>
      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_1']"
        :is-editable="isEditable"
        filetype="doc"
        index="1"
        key="1"
      />

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      login_type: localStorage.getItem('login_type'),
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
